<script>
export default {
  props: {
    transaction: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      loading: false,
      item: {},
      filters: {
        q: null,
      }
    }
  },
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.loading = true

      this.$http.get(this.routeUri('hyperion.transaction.show', {
        transaction_uuid: this.transaction
      }) + '?q=')
        .then((response) => this.item = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" class="p-0">
    <a-skeleton :loading="loading" active>
      <div class="code-bg">
        <vue-json-pretty :data="item" :deep="1"/>
        <div class="extra">
          <a-button type="link" icon="copy"
                    @click="copy(JSON.stringify(item, null, 1), 'Source has been copied to your clipboard.')"/>
        </div>
      </div>
    </a-skeleton>
  </a-card>
</template>
